export function removeEmptyValues(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let value = obj[key]

      // Check if the value is an object with a 'value' key that is an empty string
      if (typeof value === "object" && value !== null) {
        if (value.value === "") {
          delete obj[key]
        } else if (typeof value === "object" && !Array.isArray(value)) {
          obj[key] = value.value
        }
      }

      // Remove keys with empty strings or empty arrays
      if (value === "" || (Array.isArray(value) && value.length === 0)) {
        delete obj[key]
      }
    }
  }
  return obj
}

